// src/pages/ResetPassword.tsx

import {
  Box,
  Button,
  TextField,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { enqueueSnackbar } from "notistack";
import resetPassword from "@/services/auth/reset";
import { YELLOW_COLOR } from "@/constants/color";

const schema = yup.object({
  password: yup.string().min(5).required("Campo requerido"),
});

type FormData = yup.InferType<typeof schema>;

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({ resolver: yupResolver(schema) });

  const onSubmit = async (data: FormData) => {
    if (!token) return;

    try {
      await resetPassword(token, data.password);
      enqueueSnackbar("Contraseña actualizada", { variant: "success" });
      navigate("/auth/login");
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Error de red", { variant: "error" });
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      p={2}
    >
      <Card
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 400,
          boxShadow: 10,
          backgroundColor: "rgba(255, 255, 255, 0.03)",
          backdropFilter: "blur(7px)",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ color: "#e3e3e3" }}
            gutterBottom
          >
            Restablecer contraseña
          </Typography>

          <Box component="form" onSubmit={handleSubmit(onSubmit)} mt={2}>
            <TextField
              label="Nueva contraseña"
              type="password"
              fullWidth
              {...register("password")}
              error={!!errors.password}
              helperText={errors.password?.message}
              margin="normal"
              InputLabelProps={{
                style: { color: "#e3e3e3" },
              }}
              InputProps={{
                style: { color: "#e3e3e3" },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#e3e3e3" },
                  "&:hover fieldset": { borderColor: "#e3e3e3" },
                  "&.Mui-focused fieldset": { borderColor: "#e3e3e3" },
                },
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2, backgroundColor: YELLOW_COLOR }}
            >
              Guardar
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
